import { observer } from 'mobx-react';
import * as React from 'react';
import { translate, ITranslationsCollection, ServiceView } from 'elc-service';
import { PRODUCT_GRID } from 'elc-service-view-names';
import styled from 'styled-components';
import { IItem } from '../../internal/interfaces/ISearchInterfaces';
import { IItemTypeahead, INumRecs, IToutItem } from '../interfaces/ISearchInterfaces';
import { SearchSuggestion } from '../views/search-suggestion/SearchSuggestion';
import { SearchResultsMessage } from './SearchResultsMessage';
import { SearchConfigs } from '../configs/SearchConfigs';
import { TOGGLE_TYPE } from '../constants/Search';
import { classes } from '../utils/Classes';

export interface ISearchMppGrid {
    config: {
        content?: IToutItem[];
        searchItems: IItem[];
        bestSellerItems: IItem[];
        productGridBreakpoints?: object;
        hideProductPrice?: boolean;
        hideProductBadge?: boolean;
        showSubDisplayName?: boolean;
        hideProductRating?: boolean;
        enableNotifyMe?: boolean;
        enableQuickView?: boolean;
        enableMobileQuickView?: boolean;
        searchUrl?: string;
        ctaType?: string;
        enableAutoReplenishment?: boolean;
        autoReplenishOptions?: number[];
        autoReplenishToggleType?: TOGGLE_TYPE;
    };
    className?: string;
    inputValue: string;
    resultsLoaded: boolean;
    isLoading: boolean;
    translations?: ITranslationsCollection;
    numRecs: INumRecs;
    contentRecs?: number;
    limiteTypeaheadResults: IItemTypeahead[];
    typeaheadResults: IItemTypeahead[];
    resultType: number;
    adjustedTerm: string;
    searchTermSelected(searchTerm: string): () => void;
    view: number;
    filteredBy: boolean;
    dynamicTouts: IToutItem[];
    useSquareBrackets: boolean;
}

const SearchResultsWrapper = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
`;

const SearchGridWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
`;

@translate(['bestSellersProductsTitle'])
@observer
export class SearchGrid extends React.Component<ISearchMppGrid> {
    public static defaultProps: ISearchMppGrid;
    private searchresultsWrapper: string = classes('search-results-wrapper');
    private searchresultsWrappersMessage: string = classes('search-results-wrapper-message');
    private searchGridClassnames: string = classes('search-grid-wrapper');
    public render() {
        const translations = this.props.translations as ITranslationsCollection;

        let content = this.props.config.content;

        const {
            inputValue,
            resultsLoaded,
            numRecs,
            contentRecs,
            adjustedTerm,
            limiteTypeaheadResults,
            typeaheadResults,
            resultType,
            searchTermSelected,
            view,
            dynamicTouts,
            filteredBy,
            useSquareBrackets,
            config: {
                searchItems,
                bestSellerItems,
                productGridBreakpoints,
                hideProductPrice,
                hideProductBadge,
                showSubDisplayName,
                hideProductRating,
                enableNotifyMe,
                enableQuickView,
                enableMobileQuickView,
                searchUrl,
                ctaType,
                enableAutoReplenishment,
                autoReplenishOptions,
                autoReplenishToggleType
            }
        } = this.props;

        if (dynamicTouts && dynamicTouts.length) {
            content = dynamicTouts;
        }

        if (filteredBy) {
            content = [];
        }

        const searchDrupalConfigs = {
            content,
            productGridBreakpoints,
            hideProductBadge,
            showSubDisplayName,
            hideProductPrice,
            hideProductRating,
            enableNotifyMe,
            enableQuickView,
            enableMobileQuickView,
            hideSorting: SearchConfigs.hideSorting,
            filterData: SearchConfigs.filterData,
            translations,
            ctaType,
            enableAutoReplenishment,
            autoReplenishOptions,
            autoReplenishToggleType
        };

        const searchViewConfig = {
            items: searchItems,
            ...searchDrupalConfigs,
            searchUrl
        };

        const bestSellerViewConfig = {
            items: bestSellerItems,
            ...searchDrupalConfigs
        };

        return searchViewConfig.items.length > 0 && resultsLoaded ? (
            <SearchResultsWrapper className={this.searchresultsWrapper}>
                <SearchSuggestion
                    inputValue={inputValue}
                    searchUrl={searchUrl}
                    resultsLoaded={resultsLoaded}
                    limiteTypeaheadResults={limiteTypeaheadResults}
                    typeaheadResults={typeaheadResults}
                    searchTermSelected={searchTermSelected}
                    view={view}
                    useSquareBrackets={useSquareBrackets}
                />
                <SearchGridWrapper className={this.searchGridClassnames}>
                    <SearchResultsMessage
                        inputValue={inputValue}
                        resultsLoaded={resultsLoaded}
                        numRecs={numRecs}
                        contentRecs={contentRecs}
                        resultType={resultType}
                        adjustedTerm={adjustedTerm}
                        view={view}
                    />
                    <ServiceView name={PRODUCT_GRID} config={searchViewConfig} />
                </SearchGridWrapper>
            </SearchResultsWrapper>
        ) : (
            <SearchResultsWrapper className={this.searchresultsWrappersMessage}>
                <SearchResultsMessage
                    inputValue={inputValue}
                    resultsLoaded={resultsLoaded}
                    numRecs={numRecs}
                    contentRecs={contentRecs}
                    resultType={resultType}
                    adjustedTerm={adjustedTerm}
                    view={view}
                />
                <SearchGridWrapper className={this.searchGridClassnames}>
                    <ServiceView name={PRODUCT_GRID} config={bestSellerViewConfig} />
                </SearchGridWrapper>
            </SearchResultsWrapper>
        );
    }
}
